import React from "react";
import ConfirmationModal from "../ConfirmationModal.jsx";
import { INPUT } from "./Fields.jsx";
import { numberLabel } from "../../utils/consolidationPresentation.js";

export default function QuantityConflictDialog({ conflicts, busy, error, onCancel, onConfirm }) {
  const [choices, setChoices] = React.useState({});
  const groups = [...new Set(conflicts.map(c => c.order_id))];
  const complete = conflicts.every(c => choices[c.token]);
  return <ConfirmationModal title="Choisir les valeurs à valider" eyebrow="Consolidation"
    description={conflicts.some(c => c.baseline_known === false)
      ? "La référence initiale de certains champs de ce brouillon n’est plus disponible. Vérifiez les valeurs différentes avant de valider."
      : "Ces champs ont aussi changé pendant votre saisie. Choisissez les valeurs à utiliser pour ce relevé."}
    tone="accent" cornerRadius="grain" contentDensity="compact" confirmLabel="Valider avec ces valeurs"
    confirmDisabled={!complete} isBusy={busy} errorMessage={error} onCancel={onCancel}
    onConfirm={() => onConfirm(conflicts.map(c => ({ order_id: c.order_id, field: c.field, token: c.token, choice: choices[c.token] })))}>
    <div className="grid min-w-0 gap-3">
      {groups.map(oid => <section key={oid} className="grid min-w-0 gap-2 rounded-[4px] border border-slate-200 p-2">
        <h3 className="text-sm font-semibold">{conflicts.find(c => c.order_id === oid).order_label}</h3>
        {conflicts.filter(c => c.order_id === oid).map(c => <div key={c.token} className="grid min-w-0 gap-1 text-xs">
          <strong>{c.label} ({c.unit})</strong>
          <div className="grid gap-1 sm:grid-cols-2"><span>Votre saisie : <strong>{numberLabel(c.mine, 4)} {c.unit}</strong></span><span>Valeur actuellement enregistrée : <strong>{numberLabel(c.current, 4)} {c.unit}</strong></span></div>
          {c.quantity_mode === "delivered" ? <p>Chargé enregistré : {numberLabel(c.current_loaded, 3)} t · Livré enregistré : {numberLabel(c.current_delivered, 3)} t. Le choix sera appliqué au chargé et au livré. « Valeur enregistrée » utilise le livré courant.</p> : null}
          <label className="grid min-w-0 gap-1">Valeur à valider
            <select aria-label={`${c.order_label} · ${c.label}`} className={`${INPUT} w-full min-w-0`} value={choices[c.token] || ""} disabled={busy}
              onChange={event => setChoices(current => ({ ...current, [c.token]: event.target.value }))}>
              <option value="" disabled>Choisir…</option><option value="mine">Conserver ma saisie</option><option value="current">Utiliser la valeur enregistrée</option>
            </select>
          </label>
        </div>)}
      </section>)}
    </div>
  </ConfirmationModal>;
}
